export const API_MEMBER_LST = '/danh-sach-thanh-vien'